import type { ShiftServiceListResponse } from 'backend/types'
import { apiFetch } from '..'

/**
 * シフトサービス一覧取得API
 *
 * 案件作成時にSHIFTのサービスを選択できるようにするため導入。
 * バックエンドのv_shift_servicesビューから有効なサービス一覧を取得する。
 *
 * @returns シフトサービス一覧レスポンス
 */
export async function getShiftServices(): Promise<ShiftServiceListResponse> {
  return apiFetch<ShiftServiceListResponse>('/api/shift-services', { method: 'GET' })
}
